import React from "react";
import { Mui, MuiIcons } from "@osu/react-ui";
import ValidatedURL from "../../util/url-validation-utility";

const { getType: getUrlType, options } = ValidatedURL

const useStyles = Mui.makeStyles({
  svg: {
    fontSize: "1em",
  },
});

let ariaLabelSuffix = {
  [options.web]: 'in a new window',
  [options.email]: 'email',
  [options.phone]: 'phone',
  [options.text]: 'text message',
}

let iconType = {
  [options.web]: MuiIcons.OpenInNew,
  [options.email]: MuiIcons.Email,
  [options.phone]: MuiIcons.Smartphone,
  [options.text]: MuiIcons.Textsms,
}

const CustomIcon = ({ className, type, color = 'secondary' }) => {
  let props = {
    className,
    color
  }
  const ariaLabelForType = ariaLabelSuffix[type]
  const Icon = iconType[type]
  if(!Icon || !ariaLabelForType) {
    return false
  }
  if (type === options.web) {
    props.target = "_blank"
    props.rel = "noopener noreferrer"
  }

  return <sup> 
    <Icon titleAccess={`(opens ${ariaLabelForType})`} {...props} />
  </sup>
};

const ExternalLink = React.forwardRef(
  ({ children, href, Icon, type, ...rest }, ref) => {
    const classes = useStyles();
    let props = {
      ...rest,
      href,
    };
    const linkType = type || getUrlType(href);
    if (linkType === "invalid") {
      return false;
    }

    return (
      <Mui.Link ref={ref} href={href} {...props}>
        {children}
        {Icon || <CustomIcon className={classes.svg} type={linkType} />}
      </Mui.Link>
    );
  }
);

export default ExternalLink;
